import { render, staticRenderFns } from "./telzxform.vue?vue&type=template&id=e3828fb6&scoped=true&"
import script from "./telzxform.vue?vue&type=script&lang=js&"
export * from "./telzxform.vue?vue&type=script&lang=js&"
import style0 from "./telzxform.vue?vue&type=style&index=0&id=e3828fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3828fb6",
  null
  
)

export default component.exports